export interface ValidationRule { required?: boolean; minLength?: number; maxLength?: number; pattern?: RegExp; customValidator?: (value: string) => string | null;}
export interface ValidationResult { isValid: boolean; errors: Record<string, string>}
export const validateField = (value: string, rules: ValidationRule[], fieldName: string): string | null => {
  if (rules.some(rule => rule.required) && !value.trim()) {
    return `${fieldName} is required`;
  }
  if (value.trim()) {
    for (const rule of rules) {
      if (rule.minLength && value.length < rule.minLength) {
        return `${fieldName} must be at least ${rule.minLength} characters`;
      }    
      if (rule.maxLength && value.length > rule.maxLength) {
        return `${fieldName} must be less than ${rule.maxLength} characters`;
      }
      if (rule.pattern && !rule.pattern.test(value)) {
        return `${fieldName} contains invalid characters`;
      }
      if (rule.customValidator) {
        const customError = rule.customValidator(value);
        if (customError) return customError;
      }
    }
  }
  return null;
};
export const validateForm = (fields: Record<string, { value: string, rules: ValidationRule[], name: string }>): ValidationResult => {
  const errors: Record<string, string> = {};
  let isValid = true;
  for (const [key, field] of Object.entries(fields)) {
    const error = validateField(field.value, field.rules, field.name);
    if (error) {
      errors[key] = error;
      isValid = false;
    }
  }
  return { isValid, errors };
};
export const nameValidationRules: ValidationRule[] = [
  { required: true, minLength: 2 },
  { pattern: /^[a-zA-Z\s-']+$/, customValidator: (value) => 
    !/^[a-zA-Z\s-']+$/.test(value) ? "Can only contain letters, spaces, hyphens, and apostrophes" : null 
  }
];
export const emailValidationRules: ValidationRule[] = [
  { required: true },
  { pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, customValidator: (value) => 
    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? "Please enter a valid email address" : null 
  }
];